module.exports = __webpack_public_path__ + "img/4-1_03.2ff5116b.jpg";